"use strict";

import Dom from "common/Dom";
import * as themeA11y from "@shopify/theme-a11y";
import * as handlers from "scripts/components/Overlay/handlers";
import * as handlers2 from "scripts/components/Scroll/handlers";
var options = void 0;
var selectedVariantID = void 0;
var variantId = void 0;
var cartCount = void 0;
var lastCartFocus = null;
var OUT_OF_STOCK_MESSAGE = "Sorry, that product is out of stock!";
var OVER_LIMIT_MESSAGE =
  "Sorry, you have reached the maximum quantity of this product.";

var resolveElement = function resolveElement(element) {
  if (!element) return null;
  if (element instanceof Element) return element;
  if (element[0] instanceof Element) return element[0];
  return null;
};

var getCartCloseButton = function getCartCloseButton() {
  var $visibleBlock = $(Dom.cartEmpty).is(":visible")
    ? $(Dom.cartEmpty)
    : $(Dom.inlineCart).find(Dom.cartFull).first();
  return $visibleBlock.find(Dom.cartHide)[0] || null;
};

var activateCartFocus = function activateCartFocus() {
  var container = $(Dom.inlineCart)[0];
  var closeButton = getCartCloseButton();

  if (!container || !closeButton) {
    return;
  }

  themeA11y.trapFocus(container, {
    elementToFocus: closeButton,
  });
};

var deferCartFocus = function deferCartFocus() {
  var $cart = $(Dom.inlineCart);
  var focused = false;

  var tryFocus = function tryFocus() {
    if (focused) {
      return;
    }

    var closeButton = getCartCloseButton();
    if (!closeButton) {
      return;
    }

    focused = true;
    activateCartFocus();
  };

  requestAnimationFrame(function () {
    requestAnimationFrame(tryFocus);
  });

  $cart.one("transitionend", tryFocus);
};

var _error2 = function error(_error, message) {
  console.error("Error " + _error);
  if (message && message.length > 0) {
    alert(message);
  }
};
var _success = function _success(data, textStatus, jqXHR) {
  updateCart();
  if (!$(Dom.inlineCart).hasClass("is-active")) {
    showCart();
  }
};
export const showCart = function showCart(opener) {
  var wasActive = $(Dom.inlineCart).hasClass("is-active");
  var resolvedOpener = resolveElement(opener);

  if (resolvedOpener) {
    lastCartFocus = resolvedOpener;
  } else if (
    !wasActive &&
    document.activeElement &&
    document.activeElement !== document.body
  ) {
    lastCartFocus = document.activeElement;
  }

  $(Dom.inlineCart).addClass("is-active").attr("aria-hidden", "false");
  handlers.showOverlay();
  handlers2.scrollLock();

  if (!wasActive) {
    deferCartFocus();
  }
};
export const hideCart = function hideCart() {
  themeA11y.removeTrapFocus();
  $(Dom.inlineCart).removeClass("is-active").attr("aria-hidden", "true");
  handlers.hideOverlay();
  handlers2.scrollUnlock();

  if (lastCartFocus && typeof lastCartFocus.focus === "function") {
    lastCartFocus.focus();
  }
  lastCartFocus = null;
};
export const updateCart = function updateCart(callback) {
  $.get("/cart?view=contents", function (response) {
    $(Dom.lineItemEntryPoint).html(response);
    if (typeof callback === "function") {
      callback();
    }
  });
};
export const setCartState = function setCartState() {
  cartCount = CartJS.cart.item_count;
  var cartLabel =
    cartCount === 0
      ? "Cart, empty"
      : "Cart, " + cartCount + " item" + (cartCount === 1 ? "" : "s");
  $(Dom.cartShow).attr("aria-label", cartLabel);
  if (cartCount === 0) {
    $(Dom.cartFull).hide();
    $(Dom.cartEmpty).show();
    $(Dom.cartIconEmpty).removeClass("u-visually-hidden");
    $(Dom.cartIconFull).addClass("u-visually-hidden");
  } else {
    $(Dom.cartFull).show();
    $(Dom.cartEmpty).hide();
    $(Dom.cartIconEmpty).addClass("u-visually-hidden");
    $(Dom.cartIconFull).removeClass("u-visually-hidden");
  }
};
export const addCartItem = function addCartItem(variantId, quantity) {
  window.CartJS.addItem(
    variantId,
    quantity,
    {},
    {
      success: _success,
      error: function error(jqXHR, textStatus, errorThrown) {
        return _error2(errorThrown, OUT_OF_STOCK_MESSAGE);
      },
    },
  );
};
export const updateLineItem = function updateLineItem(varaintId, quantity) {
  window.CartJS.updateItemById(
    variantId,
    quantity,
    {},
    {
      success: _success,
      error: function error(jqXHR, textStatus, errorThrown) {
        return _error2(errorThrown);
      },
    },
  );
};
var checkQuantityLimit = function checkQuantityLimit(
  quantityLimit,
  productType,
  newQuantity,
) {
  if (isNaN(quantityLimit)) {
    if (productType === "medical-thermometers" && newQuantity > 2) {
      alert(OVER_LIMIT_MESSAGE);
      return false;
    }
  } else {
    if (newQuantity > quantityLimit) {
      alert(OVER_LIMIT_MESSAGE);
      return false;
    }
  }
  return true;
};
export const updateQuantityByText = function updateQuantityByText($this) {
  var variantId = parseInt(
    $this.closest("[data-line-item]").attr("data-variant-id"),
    10,
  );
  var quantityLimit = parseInt(
    $this.closest("[data-line-item]").attr("data-quantity-limit"),
    10,
  );
  var productType = $this.closest("[data-line-item]").attr("data-product-type");
  var newQuantity = parseInt($this.val());
  if (checkQuantityLimit(quantityLimit, productType, newQuantity)) {
    window.CartJS.updateItemById(
      variantId,
      newQuantity,
      {},
      {
        success: _success,
        error: function error(jqXHR, textStatus, errorThrown) {
          return _error2(errorThrown);
        },
      },
    );
  }
};
export const updateQuantityByIncrement = function updateQuantityByIncrement(
  $this,
) {
  var direction = $this.attr("data-quantity-change");
  var variantId = parseInt(
    $this.closest("[data-line-item]").attr("data-variant-id"),
    10,
  );
  var currentQuantity = parseInt(
    $this.siblings("[data-quantity-number]").val(),
  );
  var quantityLimit = parseInt(
    $this.closest("[data-line-item]").attr("data-quantity-limit"),
    10,
  );
  var newQuantity =
    direction === "up" ? currentQuantity + 1 : currentQuantity - 1;
  var productType = $this.closest("[data-line-item]").attr("data-product-type");
  if (direction === "up") {
    if (checkQuantityLimit(quantityLimit, productType, newQuantity)) {
      window.CartJS.updateItemById(
        variantId,
        newQuantity,
        {},
        {
          success: function success(response) {
            var item = response.items.find(function (item) {
              return item.id === variantId;
            });
            if (item.quantity < newQuantity) {
              alert(OUT_OF_STOCK_MESSAGE);
            } else {
              _success();
            }
          },
          error: function error(jqXHR, textStatus, errorThrown) {
            return _error2(errorThrown, OUT_OF_STOCK_MESSAGE);
          },
        },
      );
    }
  } else {
    if (currentQuantity === 1) {
      removeLineItem(variantId);
    } else {
      window.CartJS.updateItemById(
        variantId,
        newQuantity,
        {},
        {
          success: _success,
          error: function error(jqXHR, textStatus, errorThrown) {
            return _error2(errorThrown);
          },
        },
      );
    }
  }
};
export const removeLineItem = function removeLineItem(variantId) {
  window.CartJS.removeItemById(variantId, {
    success: _success,
    error: function error(jqXHR, textStatus, errorThrown) {
      return _error2(errorThrown);
    },
  });
};
export const toDollars = function toDollars(cents) {
  return (cents / 100.0).toFixed(2);
};
export const updateSubtotal = function updateSubtotal() {
  var subtotal = toDollars(window.CartJS.cart.total_price);
  $(Dom.cartSubtotal).text(subtotal).prepend("$");
};
